import { posthogEvents } from '@/shared/constants/constants';
import { posthogLog } from '@/shared/pinia/modules/posthog/logger';
import { getProductDataFromHTML } from '@/shared/utils/product';

type VariantSelectedData = {
  product_id: string;
  product_sku: string;
  product_type: string;
  variant_id: number;
  product_variant: string;
  in_stock: boolean;
  inventory_count: number;
  previous_variant_id: number | null;
  selection_index: number;
};

export const trackVariantSelected = (
  option: HydratedShopifyVariant,
  previous: HydratedShopifyVariant | null,
  selectionIndex: number
) => {
  const { productId, productType, entityType } = getProductDataFromHTML();

  const eventData: VariantSelectedData = {
    product_id: productId || '',
    product_sku: option.sku || '',
    product_type: productType || entityType || 'product',
    variant_id: option.id,
    product_variant: option.title,
    in_stock: option.inStock,
    inventory_count: option.stockData,
    previous_variant_id: previous?.id ?? null,
    selection_index: selectionIndex
  };

  posthogLog('Tracking variant selected event:', eventData);

  window.posthog?.capture(posthogEvents.VARIANT_SELECTED, eventData);
};
